import api from '../../helpers/api';

import {
  SET_SOLICITUD_ID,
  REFRESCAR_ULTIMAS_AUTORIZACIONES,
  REFRESCAR_ULTIMAS_AUTORIZACIONES_INICIO,
  //REFRESCAR_ULTIMAS_AUTORIZACIONES_ERROR,
  CANCELAR_AUTORIZACION,
  ADD_AUTORIZACION_LISTA_SOLICITUDES,
  ERROR_AUTORIZACIONES_POST,
} from '../types';

const setterSolicitudId = (reservas) => ({
  type: SET_SOLICITUD_ID,
  payload: reservas,
});

export const addAutorizacionesSolitudAction = (autorizacion) => ({
  type: ADD_AUTORIZACION_LISTA_SOLICITUDES,
  payload: autorizacion,
});

const refrescarUltimasAutorizacionesAction = (reservas) => ({
  type: REFRESCAR_ULTIMAS_AUTORIZACIONES,
  payload: reservas,
});

const cancelarAutorizacionAction = (reserva) => ({
  type: CANCELAR_AUTORIZACION,
  payload: reserva,
});

const errorPostAutorizacionAction = (error) => ({
  type: ERROR_AUTORIZACIONES_POST,
  payload: error,
});

const refrescarUltimasAutorizacionesInicio = () => ({
  type: REFRESCAR_ULTIMAS_AUTORIZACIONES_INICIO,
});

// const refrescarUltimasAutorizacionesError = (error) => ({
//   type: REFRESCAR_ULTIMAS_AUTORIZACIONES_ERROR,
//   payload: error,
// });

export const getSolicitudId = (token) => {
  return async (dispatch) => {
    try {
      // TODO: request
      const solicitudID = await api.post(
        `v1/solicitudes`,
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      );

      dispatch(setterSolicitudId(solicitudID));
    } catch (ex) {
      // TODO
    }
  };
};

export const enviarAutorizacion = (
  token,
  solicitudID,
  obj,
  setSuccess = false,
  reasignarAutorizacionId = false
) => {
  return async (dispatch) => {
    try {
      const body = [obj.serviciosSeleccionados.ida.servicio];

      if (!solicitudID) {
        const r = await api.post(
          `v1/solicitudes`,
          {},
          {
            headers: {
              Authorization: token,
            },
          }
        );
        solicitudID = r.data.id;
      }

      await api.post(
        `v1/solicitudes/${solicitudID}/agregar`,
        { servicios: body },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (reasignarAutorizacionId) {
        await api.put(`v1/autorizaciones/${reasignarAutorizacionId}/reasignada`, null, {
          headers: {
            Authorization: token,
          },
        });
      }

      dispatch(refrescarAutorizacionesSolitudAction(token, solicitudID));
      dispatch(refrescarUltimasAutorizaciones(token));
      if (setSuccess) setSuccess(true);
    } catch (ex) {
      if (ex.response) {
        dispatch(
          errorPostAutorizacionAction({
            message:
              ex.response.status === 400
                ? armarMensaje(ex.response.data)
                : 'Error al enviar la autorizacion',
          })
        );
      } else {
        errorPostAutorizacionAction({
          message: 'Error al enviar la autorizacion',
        });
      }
      if (setSuccess) setSuccess(false);
    }
  };
};

const armarMensaje = (data) => {
  if (data.code === 4002) {
    return data.message;
  } else {
    return data.message;
  }
};

export const refrescarUltimasAutorizaciones = (token) => {
  return async (dispatch) => {
    try {
      dispatch(refrescarUltimasAutorizacionesInicio());

      const response = await api.get('v1/autorizaciones?page=1&limit=1000', {
        headers: {
          Authorization: token,
        },
      });

      dispatch(refrescarUltimasAutorizacionesAction(response.data.results));
    } catch (ex) {
      //dispatch(refrescarUltimasAutorizacionesError(ex.message));
    }
  };
};

export const refrescarAutorizacionesSolitudAction = (token, solicitudID) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`v1/autorizaciones?solicitudId=${solicitudID}`, {
        headers: {
          Authorization: token,
        },
      });

      dispatch(addAutorizacionesSolitudAction(response.data.results));
    } catch (ex) {
      //dispatch(refrescarUltimasAutorizacionesError(ex.message));
    }
  };
};

export const cancelarAutorizacion = (reserva) => {
  return async (dispatch) => {
    try {
      // TODO: request
      dispatch(cancelarAutorizacionAction(reserva));
    } catch (ex) {
      // TODO
    }
  };
};
